// 平台标识配置
// 默认是袋鼠
const lianxinConfig = {
    logo: require("@/assets/images/lianxin/logo.png"),
    defaultOrgImg: require('@/assets/images/default-logo-7.png'),
    bannerOrg: require('@/assets/images/lianxin/banner-org.png'),
    bannerOrgV2: require('@/assets/images/lianxin/defaultOrgBanner.png'),
    bannerPackage: require('@/assets/images/lianxin/banner-package.png'),
    daishuPhone: '4001-0755-70',
    companyName: '莲心健康',
    detailCompanyName: "懋化堂健康科技（北京）有限公司",
    parentCompany: "懋化堂健康科技（北京）有限公司",
    agreeText1: "1、本平台提供的体检服务以及体检报告解读服务和技术服务由懋化堂健康科技（北京）有限公司提供！",
    reportBanner: require('@/assets/images/lianxin/repoprtBanner.png'),
    shareParams: {
        title: '莲心健康',
        desc: '专业预约体检，就上莲心健康。',
        link: document.URL,
        imgUrl: appPath + 'resource/images/lianxinLogo.png',
        implementRequest: true // 是否重新获取设置分享配置
    },
    showDaishu: false, // 是否展示袋鼠标识
    dmi: false, // 是否展示d米
    medicalCard: false, // 是否展示卡券
    noSearchResult: require("@/assets/images/lianxin/none.png"), // 搜索页缺省图
}

export default lianxinConfig